import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import CoursesPage from "@/pages/CoursesPage";
import CourseDetailPage from "@/pages/CourseDetailPage";
import ConsultancyPage from "@/pages/ConsultancyPage";
import DemoClassPage from "@/pages/DemoClassPage";
import ContactPage from "@/pages/ContactPage";
import StudyMaterialPage from "@/pages/StudyMaterialPage";
import GalleryPage from "@/pages/GalleryPage";
import FAQPage from "@/pages/FAQPage";
import LocationPage from "@/pages/LocationPage";
import LocationCoursePage from "@/pages/LocationCoursePage";
import ResourcesPage from "@/pages/ResourcesPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ProgramsIndexPage from "@/pages/ProgramsIndexPage";
import ProgramPage from "@/pages/ProgramPage";
import NotificationsPage from "@/pages/NotificationsPage";
import NotificationDetailPage from "@/pages/NotificationDetailPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import AdminBlogs from "@/pages/admin/AdminBlogs";
import AdminGallery from "@/pages/admin/AdminGallery";
import { AdminProtected } from "@/pages/admin/adminApi";
import { Toaster } from "@/components/ui/sonner";
import { FloatingCTA } from "@/components/FloatingCTA";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/courses/:slug" element={<CourseDetailPage />} />
          <Route path="/consultancy" element={<ConsultancyPage />} />
          <Route path="/demo-class" element={<DemoClassPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/study-material" element={<StudyMaterialPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/locations/:locationSlug" element={<LocationPage />} />
          <Route path="/locations/:locationSlug/:courseSlug" element={<LocationCoursePage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/resources/:slug" element={<BlogPostPage />} />
          <Route path="/programs" element={<ProgramsIndexPage />} />
          <Route path="/programs/:slug" element={<ProgramPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/notifications/:id" element={<NotificationDetailPage />} />
        </Routes>
      </main>
      <Footer />
      <FloatingCTA />
      <ExitIntentPopup />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminProtected><AdminLayout /></AdminProtected>}>
          <Route index element={<AdminNotifications />} />
          <Route path="notifications" element={<AdminNotifications />} />
          <Route path="blogs" element={<AdminBlogs />} />
          <Route path="gallery" element={<AdminGallery />} />
        </Route>
        <Route path="/*" element={<PublicLayout />} />
      </Routes>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
